import { graphql } from 'gatsby';

export const FaqSliceFragment = graphql`
    fragment PrismicFaqFragment on PRISMIC_PageBodyFaq {
        type
        primary {
            faq_title
            faq_note
            faq_theme
            faq_multiple_open_items
        }
        fields {
            faq_question
            faq_answer
        }
    }
`;
